// Gang Sheet Builder — Shopify port
// Reads config from window.GSB_CONFIG (set by sections/gang-sheet-builder.liquid)
(function () {
  const CFG = window.GSB_CONFIG || {};
  const SIZES = CFG.sizes || [];
  if (!SIZES.length) {
    for (let h = 10; h <= 300; h += 10) SIZES.push({ in: h, price: +(h * 0.42).toFixed(2) });
  }

  // Physical constants — every placed design is stored in REAL INCHES so its
  // size doesn't warp when the sheet length changes, and the layout sent to
  // the printer has accurate dimensions.
  const SHEET_WIDTH_IN = 13;
  const DPI = 300; // Standard DTF resolution — 3000 px = 10"

  let library = [];   // { id, name, dataURL, remoteURL, naturalW, naturalH, uploading }
  let placed = [];    // { libId, xIn, yIn, widthIn, heightIn }  (real inches on the sheet)
  let selectedIdx = null;
  let drag = null;
  let nextId = 1;
  let product = null;

  function currentSheetLen() {
    const sel = $('gsbSize');
    const idx = parseInt(sel?.value || 0);
    return (SIZES[idx] || SIZES[0] || { in: 30 }).in;
  }
  function clamp(v, min, max) { return Math.max(min, Math.min(max, v)); }

  // Detect the tight bounding box of non-transparent pixels and return a
  // trimmed dataURL + dimensions. Falls back to the original if pixel access
  // is blocked (cross-origin) or the image has no alpha at all.
  function trimTransparent(img) {
    const original = { dataURL: null, width: img.naturalWidth, height: img.naturalHeight, trimmed: false };
    try {
      const c = document.createElement('canvas');
      c.width = img.naturalWidth; c.height = img.naturalHeight;
      const ctx = c.getContext('2d');
      ctx.drawImage(img, 0, 0);
      const data = ctx.getImageData(0, 0, c.width, c.height).data;
      let minX = c.width, minY = c.height, maxX = -1, maxY = -1;
      for (let y = 0; y < c.height; y++) {
        for (let x = 0; x < c.width; x++) {
          const alpha = data[(y * c.width + x) * 4 + 3];
          if (alpha > 8) {
            if (x < minX) minX = x;
            if (x > maxX) maxX = x;
            if (y < minY) minY = y;
            if (y > maxY) maxY = y;
          }
        }
      }
      // If we found no bounds or the image is already tight, return as-is
      if (maxX < 0) {
        original.dataURL = c.toDataURL();
        return original;
      }
      const w = maxX - minX + 1, h = maxY - minY + 1;
      const slackFraction = 1 - (w * h) / (c.width * c.height);
      if (slackFraction < 0.02) {
        original.dataURL = c.toDataURL();
        return original;
      }
      const out = document.createElement('canvas');
      out.width = w; out.height = h;
      out.getContext('2d').drawImage(c, minX, minY, w, h, 0, 0, w, h);
      return { dataURL: out.toDataURL('image/png'), width: w, height: h, trimmed: true };
    } catch (e) {
      console.warn('trim failed', e);
      original.dataURL = null;
      return original;
    }
  }

  const $ = id => document.getElementById(id);
  const canvas = $('gsbCanvas');
  if (!canvas) return; // section not on this page
  const emptyHint = $('gsbEmptyHint');

  // ── PRODUCT LOAD ───────────────────────────────────────
  async function loadProduct() {
    if (!CFG.productHandle) return;
    try {
      const res = await fetch(`/products/${CFG.productHandle}.js`);
      if (res.ok) product = await res.json();
    } catch (e) { console.warn('Product load failed:', e); }
  }

  function findVariantBySize(inches) {
    if (!product) return null;
    // Extract all numbers from a string; match if the target inches appears as a standalone number.
    const target = String(inches);
    const matchNum = (s) => {
      const nums = String(s).match(/\d+(?:\.\d+)?/g) || [];
      return nums.includes(target);
    };
    const v = product.variants.find(v => {
      if (matchNum(v.title)) return true;
      return (v.options || []).some(o => matchNum(o));
    });
    if (!v) console.warn('[gang-sheet] no variant for size', inches, '— variants seen:', product.variants.map(x => x.title));
    return v || null;
  }

  // ── SIZE DROPDOWN ──────────────────────────────────────
  function populateSizes() {
    const sel = $('gsbSize');
    sel.innerHTML = SIZES.map((s, i) =>
      `<option value="${i}"${s.in === 30 ? ' selected' : ''}>13 in × ${s.in} in — $${s.price.toFixed(2)}</option>`
    ).join('');
    sel.addEventListener('change', () => {
      const s = SIZES[parseInt(sel.value)];
      canvas.style.setProperty('--sheet-h', s.in);
      // Clip any placed design that now falls off the shorter sheet
      placed.forEach(p => {
        if (p.yIn + p.heightIn > s.in) p.yIn = Math.max(0, s.in - p.heightIn);
        if (p.heightIn > s.in) { const scale = s.in / p.heightIn; p.widthIn *= scale; p.heightIn *= scale; }
      });
      renderPlaced();
      updatePrice();
    });
  }

  // ── UPLOAD (design captured locally; sent to R2 at Add to Cart) ─
  const fileInput = $('gsbFileInput');
  const uploadZone = $('gsbUploadZone');
  uploadZone.addEventListener('dragover', e => { e.preventDefault(); uploadZone.classList.add('dragover'); });
  uploadZone.addEventListener('dragleave', () => uploadZone.classList.remove('dragover'));
  uploadZone.addEventListener('drop', e => {
    e.preventDefault(); uploadZone.classList.remove('dragover');
    if (e.dataTransfer.files.length) handleFiles(e.dataTransfer.files);
  });
  fileInput.addEventListener('change', e => { if (e.target.files.length) handleFiles(e.target.files); });

  function handleFiles(files) {
    for (const f of files) {
      if (!f.type.startsWith('image/')) continue;
      if (f.size > 500 * 1024 * 1024) { alert(`${f.name} is over 500 MB — skipping.`); continue; }
      const reader = new FileReader();
      reader.onload = ev => {
        const img = new Image();
        img.onload = async () => {
          const trimmed = trimTransparent(img);
          const entry = {
            id: nextId++, name: f.name,
            file: f,                              // keep original File for deferred R2 upload
            dataURL: trimmed.dataURL,
            originalDataURL: ev.target.result,
            remoteURL: null,
            naturalW: trimmed.width,
            naturalH: trimmed.height,
            originalW: img.naturalWidth,
            originalH: img.naturalHeight,
            trimmed: trimmed.trimmed,
            uploading: false
          };
          library.push(entry);
          renderLibrary();
        };
        img.src = ev.target.result;
      };
      reader.readAsDataURL(f);
    }
  }

  const UPLOAD_WORKER_URL = 'https://txdtf-upload.txdtfprinting.workers.dev/sign-upload';

  async function uploadEntryToR2(entry, onProgress) {
    if (entry.remoteURL || !entry.file) return entry.remoteURL;
    const signRes = await fetch(UPLOAD_WORKER_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        filename: entry.file.name,
        contentType: entry.file.type || 'application/octet-stream',
        size: entry.file.size
      })
    });
    if (!signRes.ok) {
      const err = await signRes.json().catch(() => ({ error: signRes.statusText }));
      throw new Error(err.error || 'Failed to prepare upload for ' + entry.name);
    }
    const { uploadUrl, publicUrl } = await signRes.json();
    await new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('PUT', uploadUrl);
      xhr.setRequestHeader('Content-Type', entry.file.type || 'application/octet-stream');
      xhr.upload.onprogress = e => {
        if (e.lengthComputable && onProgress) onProgress((e.loaded / e.total) * 100);
      };
      xhr.onload = () => xhr.status >= 200 && xhr.status < 300 ? resolve() : reject(new Error(`Upload failed: ${xhr.status}`));
      xhr.onerror = () => reject(new Error('Network error'));
      xhr.send(entry.file);
    });
    entry.remoteURL = publicUrl;
    return publicUrl;
  }

  function renderLibrary() {
    const grid = $('gsbLibraryGrid');
    $('gsbLibCount').textContent = library.length;
    if (!library.length) { grid.innerHTML = ''; return; }
    grid.innerHTML = library.map(l => `
      <div class="lib-thumb${l.uploading ? ' uploading' : ''}" data-id="${l.id}" onclick="window.gsbPlace(${l.id})">
        <img src="${l.dataURL}" alt="">
        <div class="lib-name">${escapeHtml(l.name)}</div>
        <button class="lib-remove" onclick="event.stopPropagation();window.gsbRemoveLib(${l.id})" aria-label="Remove">✕</button>
        <div class="add-hint">+ Add to sheet</div>
      </div>
    `).join('');
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  }

  window.gsbRemoveLib = function (id) {
    library = library.filter(l => l.id !== id);
    placed = placed.filter(p => p.libId !== id);
    selectedIdx = null;
    renderLibrary(); renderPlaced(); updatePrice();
  };

  // ── PLACE / SELECT / DELETE / DUPLICATE ────────────────
  window.gsbPlace = function (libId) {
    const lib = library.find(l => l.id === libId);
    if (!lib) return;
    // Convert pixel dimensions to inches at 300 DPI (standard DTF resolution).
    let widthIn = lib.naturalW / DPI;
    let heightIn = lib.naturalH / DPI;
    const sheetLen = currentSheetLen();
    // If the image is bigger than the sheet, shrink it proportionally to fit
    // (but preserve aspect ratio). Otherwise leave it at its real size.
    if (widthIn > SHEET_WIDTH_IN) {
      const scale = SHEET_WIDTH_IN / widthIn;
      widthIn *= scale; heightIn *= scale;
    }
    if (heightIn > sheetLen) {
      const scale = sheetLen / heightIn;
      widthIn *= scale; heightIn *= scale;
    }
    // Center placement with slight random offset so stacked adds don't overlap
    const xIn = clamp((SHEET_WIDTH_IN - widthIn) / 2 + (Math.random() - 0.5) * 0.8, 0, SHEET_WIDTH_IN - widthIn);
    const yIn = clamp((sheetLen - heightIn) / 2 + (Math.random() - 0.5) * 1.5, 0, sheetLen - heightIn);
    placed.push({ libId, xIn, yIn, widthIn, heightIn });
    selectedIdx = placed.length - 1;
    renderPlaced(); updatePrice();
  };

  function selectPlaced(idx) { selectedIdx = idx; renderPlaced(); syncSelectedPanel(); }

  // Manual size entry — shown when a design is selected on the sheet.
  function syncSelectedPanel() {
    const panel = $('gsbSelectedPanel');
    if (!panel) return;
    if (selectedIdx == null || !placed[selectedIdx]) {
      panel.style.display = 'none';
      return;
    }
    panel.style.display = '';
    const p = placed[selectedIdx];
    const wIn = $('gsbSelWidth'), hIn = $('gsbSelHeight');
    if (wIn && document.activeElement !== wIn) wIn.value = p.widthIn.toFixed(2);
    if (hIn && document.activeElement !== hIn) hIn.value = p.heightIn.toFixed(2);
    // DPI check for the currently-placed design at its actual placed size.
    const lib = library.find(l => l.id === p.libId);
    const dpiEl = $('gsbSelDpi');
    if (dpiEl && lib) {
      if (lib.naturalW && p.widthIn) {
        const effectiveDpi = lib.naturalW / p.widthIn;
        let tier = 'good', label = 'Print quality', prefix = '✓ ';
        if (effectiveDpi < 110) { tier = 'bad'; label = 'Too low — will pixelate'; prefix = '⛔ '; }
        else if (effectiveDpi < 175) { tier = 'low'; label = 'Low resolution'; prefix = '⚠ '; }
        else if (effectiveDpi < 250) { tier = 'soft'; label = 'Slightly soft'; prefix = '· '; }
        dpiEl.className = 'gsb-dpi gsb-dpi-' + tier;
        dpiEl.textContent = prefix + label + ' (' + Math.round(effectiveDpi) + ' DPI at ' + p.widthIn.toFixed(1) + '")';
        dpiEl.style.display = '';
      } else {
        dpiEl.style.display = 'none';
      }
    }
  }

  function wireSelectedPanel() {
    const wIn = $('gsbSelWidth'), hIn = $('gsbSelHeight'), lock = $('gsbLockAspect'), reset = $('gsbResetSize');
    if (!wIn || !hIn) return;
    let aspectLocked = true;
    if (lock) {
      lock.addEventListener('click', () => {
        aspectLocked = !aspectLocked;
        lock.setAttribute('aria-pressed', String(aspectLocked));
        lock.textContent = aspectLocked ? '🔒' : '🔓';
        lock.title = aspectLocked ? 'Aspect ratio locked' : 'Aspect ratio unlocked';
      });
    }
    function apply(field) {
      if (selectedIdx == null) return;
      const p = placed[selectedIdx];
      const sheetLen = currentSheetLen();
      const origAspect = p.widthIn / p.heightIn;
      let newW = parseFloat(wIn.value) || p.widthIn;
      let newH = parseFloat(hIn.value) || p.heightIn;
      if (aspectLocked) {
        if (field === 'w') newH = newW / origAspect;
        else newW = newH * origAspect;
      }
      // Clamp to sheet bounds, keep at least 0.5"
      newW = clamp(newW, 0.5, SHEET_WIDTH_IN);
      newH = clamp(newH, 0.5, sheetLen);
      // Also keep design in bounds (shift up/left if it now overflows)
      p.widthIn = newW; p.heightIn = newH;
      if (p.xIn + p.widthIn > SHEET_WIDTH_IN) p.xIn = SHEET_WIDTH_IN - p.widthIn;
      if (p.yIn + p.heightIn > sheetLen) p.yIn = sheetLen - p.heightIn;
      renderPlaced(); syncSelectedPanel(); updatePrice();
    }
    wIn.addEventListener('input', () => apply('w'));
    hIn.addEventListener('input', () => apply('h'));
    if (reset) {
      reset.addEventListener('click', () => {
        if (selectedIdx == null) return;
        const p = placed[selectedIdx];
        const lib = library.find(l => l.id === p.libId);
        if (!lib) return;
        p.widthIn = lib.naturalW / DPI;
        p.heightIn = lib.naturalH / DPI;
        renderPlaced(); syncSelectedPanel(); updatePrice();
      });
    }
  }

  window.gsbDelete = function (idx) {
    placed.splice(idx, 1); selectedIdx = null;
    renderPlaced(); updatePrice();
  };

  window.gsbDuplicate = function (idx) {
    const p = placed[idx];
    const sheetLen = currentSheetLen();
    placed.push({
      ...p,
      xIn: Math.min(p.xIn + 0.5, SHEET_WIDTH_IN - p.widthIn),
      yIn: Math.min(p.yIn + 0.5, sheetLen - p.heightIn),
    });
    selectedIdx = placed.length - 1;
    renderPlaced(); updatePrice();
  };

  function renderPlaced() {
    canvas.querySelectorAll('.placed').forEach(el => el.remove());
    if (emptyHint) emptyHint.style.display = placed.length ? 'none' : 'flex';

    const sheetLen = currentSheetLen();
    const totalArea = SHEET_WIDTH_IN * sheetLen;
    let usedArea = 0;

    placed.forEach((p, idx) => {
      const lib = library.find(l => l.id === p.libId);
      if (!lib) return;
      const el = document.createElement('div');
      el.className = 'placed' + (idx === selectedIdx ? ' selected' : '');
      // Convert inches to % of current sheet for CSS positioning
      el.style.left = (p.xIn / SHEET_WIDTH_IN * 100) + '%';
      el.style.top = (p.yIn / sheetLen * 100) + '%';
      el.style.width = (p.widthIn / SHEET_WIDTH_IN * 100) + '%';
      el.style.height = (p.heightIn / sheetLen * 100) + '%';
      el.title = `${p.widthIn.toFixed(2)}" × ${p.heightIn.toFixed(2)}"`;
      el.innerHTML = `<img src="${lib.dataURL}" alt="">`;
      if (idx === selectedIdx) {
        el.innerHTML += `
          <div class="placed-actions">
            <button onclick="event.stopPropagation();window.gsbDuplicate(${idx})" title="Duplicate">⧉</button>
            <button onclick="event.stopPropagation();window.gsbDelete(${idx})" title="Delete">✕</button>
          </div>
          <div class="placed-dims">${p.widthIn.toFixed(1)}" × ${p.heightIn.toFixed(1)}"</div>
          <div class="handle nw" data-corner="nw"></div>
          <div class="handle ne" data-corner="ne"></div>
          <div class="handle sw" data-corner="sw"></div>
          <div class="handle se" data-corner="se"></div>
        `;
      }
      el.addEventListener('pointerdown', e => onPointerDownPlaced(e, idx, el));
      canvas.appendChild(el);
      usedArea += p.widthIn * p.heightIn;
    });

    $('gsbDesignCount').textContent = placed.length;
    $('gsbUsagePct').textContent = Math.min(100, Math.round(usedArea / totalArea * 100)) + '%';
    syncSelectedPanel();
  }

  function onPointerDownPlaced(e, idx, el) {
    e.stopPropagation();
    if (e.target.tagName === 'BUTTON') return;
    selectPlaced(idx);
    const rect = canvas.getBoundingClientRect();
    const corner = e.target.dataset?.corner;
    drag = {
      idx, type: corner ? 'resize-' + corner : 'move',
      startX: e.clientX, startY: e.clientY, canvasRect: rect, initial: { ...placed[idx] }
    };
    el.setPointerCapture(e.pointerId);
  }

  document.addEventListener('pointermove', e => {
    if (!drag) return;
    const r = drag.canvasRect;
    const sheetLen = currentSheetLen();
    // Convert pixel-drag deltas to inches based on the current canvas mapping
    const dxIn = ((e.clientX - drag.startX) / r.width) * SHEET_WIDTH_IN;
    const dyIn = ((e.clientY - drag.startY) / r.height) * sheetLen;
    const p = placed[drag.idx];
    const init = drag.initial;

    if (drag.type === 'move') {
      p.xIn = clamp(init.xIn + dxIn, 0, SHEET_WIDTH_IN - p.widthIn);
      p.yIn = clamp(init.yIn + dyIn, 0, sheetLen - p.heightIn);
    } else if (drag.type.startsWith('resize-')) {
      const aspect = init.widthIn / init.heightIn;
      let newW = init.widthIn, newH = init.heightIn, newX = init.xIn, newY = init.yIn;
      const MIN_IN = 0.5;
      if (drag.type === 'resize-se') {
        newW = clamp(init.widthIn + dxIn, MIN_IN, SHEET_WIDTH_IN - init.xIn);
        newH = newW / aspect;
      } else if (drag.type === 'resize-sw') {
        newW = clamp(init.widthIn - dxIn, MIN_IN, init.xIn + init.widthIn);
        newH = newW / aspect;
        newX = init.xIn + (init.widthIn - newW);
      } else if (drag.type === 'resize-ne') {
        newW = clamp(init.widthIn + dxIn, MIN_IN, SHEET_WIDTH_IN - init.xIn);
        newH = newW / aspect;
        newY = init.yIn + (init.heightIn - newH);
      } else if (drag.type === 'resize-nw') {
        newW = clamp(init.widthIn - dxIn, MIN_IN, init.xIn + init.widthIn);
        newH = newW / aspect;
        newX = init.xIn + (init.widthIn - newW);
        newY = init.yIn + (init.heightIn - newH);
      }
      p.xIn = newX; p.yIn = newY; p.widthIn = newW; p.heightIn = newH;
    }
    renderPlaced();
  });

  document.addEventListener('pointerup', () => { drag = null; });

  canvas.addEventListener('click', e => {
    if (e.target === canvas || e.target === emptyHint) { selectedIdx = null; renderPlaced(); }
  });
  $('gsbDeselectBtn').addEventListener('click', () => { selectedIdx = null; renderPlaced(); });
  $('gsbClearBtn').addEventListener('click', () => {
    if (placed.length && !confirm('Clear all designs from the sheet?')) return;
    placed = []; selectedIdx = null;
    renderPlaced(); updatePrice();
  });

  // ── PRICE / QTY ────────────────────────────────────────
  window.gsbChangeQty = function (d) {
    const el = $('gsbQty');
    el.value = Math.max(1, parseInt(el.value || 1) + d);
    updatePrice();
  };

  function updatePrice() {
    const idx = parseInt($('gsbSize').value || 0);
    const size = SIZES[idx];
    const qty = Math.max(1, parseInt($('gsbQty').value || 1));
    let unitPrice = size.price;
    if (product) {
      const v = findVariantBySize(size.in);
      if (v) unitPrice = v.price / 100;
    }
    const total = unitPrice * qty;
    $('gsbPriceDisplay').textContent = unitPrice.toFixed(2);
    $('gsbPricePer').textContent = `${qty > 1 ? 'each' : 'per sheet'} · 13" × ${size.in}"`;
    const label = `13" × ${size.in}"`;
    $('gsbSumSize').textContent = label;
    $('gsbSumSheet').textContent = `$${unitPrice.toFixed(2)}`;
    $('gsbSumQty').textContent = qty;
    $('gsbSumTotal').textContent = total.toFixed(2);
  }
  window.gsbUpdatePrice = updatePrice;

  function stashPreview(dataURL) {
    if (!dataURL || !dataURL.startsWith('data:')) return null;
    try {
      const id = 'p_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 7);
      const store = JSON.parse(localStorage.getItem('txdtf_previews') || '{}');
      store[id] = dataURL;
      const ids = Object.keys(store);
      if (ids.length > 30) {
        const trimmed = {};
        ids.slice(-30).forEach(k => { trimmed[k] = store[k]; });
        localStorage.setItem('txdtf_previews', JSON.stringify(trimmed));
      } else {
        localStorage.setItem('txdtf_previews', JSON.stringify(store));
      }
      return id;
    } catch (e) { console.warn('preview stash failed', e); return null; }
  }

  // ── ADD TO CART ────────────────────────────────────────
  window.gsbAddToCart = async function () {
    if (!library.length) {
      alert('Please upload at least one design before adding to cart.');
      const zone = $('gsbUploadZone');
      if (zone) { zone.scrollIntoView({ behavior: 'smooth', block: 'center' }); zone.classList.add('needs-attention'); setTimeout(() => zone.classList.remove('needs-attention'), 2000); }
      return;
    }
    if (!placed.length) {
      alert('Please place at least one design on the sheet before adding to cart.');
      const canvas = $('gsbCanvas');
      if (canvas) { canvas.scrollIntoView({ behavior: 'smooth', block: 'center' }); canvas.classList.add('needs-attention'); setTimeout(() => canvas.classList.remove('needs-attention'), 2000); }
      return;
    }
    const idx = parseInt($('gsbSize').value || 0);
    const size = SIZES[idx];
    const qty = parseInt($('gsbQty').value || 1);
    const notes = $('gsbNotes')?.value || '';

    let variantId = null;
    if (product) {
      const v = findVariantBySize(size.in);
      if (v) variantId = v.id;
    }
    if (!variantId) {
      alert(`Variant for size 13" × ${size.in}" not found. Make sure the gang sheet product has a "Size" or "Title" option matching this label.`);
      return;
    }

    const btn = $('gsbAddToCartBtn');
    if (btn) { btn.disabled = true; btn.textContent = 'Preparing uploads…'; }

    // Upload every placed design's file to R2 (skip any already uploaded).
    const placedLibs = [...new Set(placed.map(p => p.libId))]
      .map(id => library.find(l => l.id === id))
      .filter(Boolean);
    for (let i = 0; i < placedLibs.length; i++) {
      const lib = placedLibs[i];
      if (lib.remoteURL) continue;
      if (btn) btn.textContent = `Uploading ${i + 1}/${placedLibs.length}…`;
      try {
        await uploadEntryToR2(lib, pct => {
          if (btn) btn.textContent = `Uploading ${i + 1}/${placedLibs.length}… ${Math.round(pct)}%`;
        });
      } catch (e) {
        alert(`Upload failed for "${lib.name}": ${e.message}\n\nPlease try again.`);
        if (btn) { btn.disabled = false; btn.textContent = '🎉 Add to Cart'; }
        return;
      }
    }

    // Serialize layout — REAL INCH coordinates so your printer can composite the sheet.
    const layout = placed.map(p => {
      const lib = library.find(l => l.id === p.libId);
      return {
        url: lib?.remoteURL || null,
        name: lib?.name,
        xIn: +p.xIn.toFixed(2),
        yIn: +p.yIn.toFixed(2),
        widthIn: +p.widthIn.toFixed(2),
        heightIn: +p.heightIn.toFixed(2),
        sourcePx: lib ? [lib.naturalW, lib.naturalH] : null
      };
    });
    const layoutJson = JSON.stringify(layout);
    const designUrls = placed.map(p => library.find(l => l.id === p.libId)?.remoteURL).filter(Boolean).join('\n');

    // Stash a browser-local preview of the first placed design so the cart can
    // render a thumbnail before the R2 URL is available.
    const firstLib = library.find(l => l.id === placed[0]?.libId);
    const previewId = firstLib ? stashPreview(firstLib.dataURL) : null;

    const properties = {
      'Sheet Size': `13" × ${size.in}"`,
      'Designs Placed': String(placed.length),
      ...(designUrls ? { 'Design URLs': designUrls } : {}),
      ...(previewId ? { 'Preview ID': previewId } : {}),
      'Layout JSON': layoutJson,
      ...(notes ? { 'Notes': notes } : {})
    };

    if (btn) btn.textContent = 'Adding to cart…';

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: qty, properties }] })
      });
      const json = await res.json();
      if (!res.ok) {
        alert('Could not add to cart: ' + (json.description || json.message || res.statusText));
        if (btn) { btn.disabled = false; btn.textContent = '🎉 Add to Cart'; }
        return;
      }
      window.location.href = '/cart';
    } catch (e) {
      alert('Network error: ' + e.message);
      if (btn) { btn.disabled = false; btn.textContent = '🎉 Add to Cart'; }
    }
  };

  // ── BOOT ───────────────────────────────────────────────
  (async function init() {
    populateSizes();
    await loadProduct();
    updatePrice();
    renderLibrary();
    renderPlaced();
    wireSelectedPanel();
    syncSelectedPanel();
  })();
})();
